/*
|-------------------------------\
|  components --> MODAL STATIC
|-------------------------------/
*/

/*
Opens a modal dialog with static
content when a button is clicked.

DEPENDENCIES
------------
scss/_5-objects/generic/_flag.scss
scss/_6-components/generic/_modal.scss
scss/_7-trumps/_other-utilities.scss .fill-height
*/

WW.modal = function($) {
    'use strict';

    let openModal,
        closeModal,
        updateIframe,
        scrollbarWidth = WW.scrollbarWidth;

    const body = $('body'),
        siteHeader = $('.c-site-header'),
        transitionDuration = 300;

    openModal = (trigger, element) => {
        body.addClass('modal-open').css({
            'padding-right' : scrollbarWidth
        });
        siteHeader.css({
            paddingRight: scrollbarWidth
        });
        element.addClass('is-open');

        if (trigger.data('video-src') && element.find('.js-modal-video').length) {
            updateIframe(
                element.find('.js-modal-video'),
                trigger.data('video-src')
                );
        }
    };

    closeModal = (element) => {
        element.removeClass('is-open');
        body.removeClass('modal-open').css({
            'padding-right' : 0
        });
        siteHeader.css({
            paddingRight: 0
        });

        if (element.find('.js-modal-video').length) {
            updateIframe(element.find('.js-modal-video'), '');
        }
    };

    updateIframe = (iframe, src) => {
        setTimeout(() => {
            iframe.attr('src', src);
        }, transitionDuration);

        if (!src) {
            iframe.closest('.js-modal-dialog')
            .find('.js-video-wrapper__cover')
            .fadeIn(transitionDuration, function() {
                $(this).slideDown(0);
            });
        }
        else {
            iframe.on('load', function() {
                $(this).closest('.js-modal-dialog')
                .find('.js-video-wrapper__cover')
                .fadeOut(600);
            });
        }
    };

    body.on('click', '.js-toggle-modal', function(e) {
        e.preventDefault();

        if ($(this).attr('data-target')) {
            const targetModal = $('#' + $(this).attr('data-target'));
            openModal($(this), targetModal);
        }
    });

    body.on('click', '.js-modal', function() {
        closeModal($(this));
    });

    $('.js-modal-close').on('click', function() {
        closeModal($(this).closest('.js-modal'));
    });

    $('.js-modal-dialog').on('click', function(e) {
        e.stopPropagation();
    });

    return this;
};

/* place the following in feature-toggle.js: .modal($) */
